import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import MainLayout from "../layout";
import ClientDetail from "./ClientDetail";
import ClientTask from "./ClientTask/ClientTask";
import ClientTicket from "./ClientTicket/ClientTicket";
import ClientNote from "./ClientNote/ClientNote";
import ClientUser from "./ClientUser/ClientUser";
import Configurations from "./Configurations/Configurations";
import ProjectPlan from "./ProjectPlan/ProjectPlan";
import { DisplayMsg } from "../../services/toastService";
import { setClientDetailTab } from "../../store/reducers/SharedLayoutDataSlice";

import { setUrl } from "../../handlers";

const MainClient = () => {
  const dispatch = useDispatch();
  const [Practice, setPractice] = useState(false);
  const location = useLocation();
  const clientId = location.state?.ClientId;
  const entityId = location.state?.EntityId;

  const currentTab = location.state?.CurrentTab;

  const [curTab, setCurTab] = useState(
    currentTab === "" ? "ClientDetail" : currentTab
  );

  const ClientDetailTab = (tab) => {
    setCurTab(tab);
    dispatch(setClientDetailTab(tab));
  };

  const TriggerPracticeSetup = (show) => {
    setPractice(show);
  };

  const RefreshPractice = async () => {
    document.getElementById("loader").style.display = "block";
    const result = await fetch(
      setUrl("PRACTICEDETAIL", "REFRESHPRACTICEDATA", true)
    );
    const response = await result.json();
    if (response && response.status) {
      DisplayMsg("1", response.Message);
    } else {
      DisplayMsg("2", response.Message);
    }
  };

  return (
    <MainLayout>
      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />

      <div
        role="tabpanel"
        className="tab-pane active page-content-wrapper"
        id="clientLink"
      >
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="tabbable">
              <div className="client-tab-buttons">
                <ul className="client-nav-tabs">
                  <li
                    className={`${curTab === "ClientDetail" ? "bg-gray-300" : ""
                      }`}
                  >
                    <span
                      data-toggle="tab"
                      aria-expanded="true"
                      className={`cursor-pointer ${curTab === "ClientDetail"
                          ? "text-decoration-none"
                          : ""
                        }`}
                      onClick={() => ClientDetailTab("ClientDetail")}
                    >
                      Client Details{" "}
                      <span className="text-lg text-red-500">*</span>
                    </span>
                  </li>

                  <li
                    className={`${curTab === "Ticket" ? "bg-gray-300" : ""}`}
                  >
                    <span
                      data-toggle="tab"
                      aria-expanded="false"
                      className={`cursor-pointer ${curTab === "Ticket" ? "text-decoration-none" : ""
                        }`}
                      onClick={() => ClientDetailTab("Ticket")}
                    >
                      Ticket <span className="text-lg" />
                    </span>
                  </li>

                  <li className={`${curTab === "Task" ? "bg-gray-300" : ""}`}>
                    <span
                      data-toggle="tab"
                      aria-expanded="false"
                      className={`cursor-pointer ${curTab === "Task" ? "text-decoration-none" : ""
                        }`}
                      onClick={() => ClientDetailTab("Task")}
                    >
                      Task <span className="text-lg" />
                    </span>
                  </li>
                  <li className={`${curTab === "Note" ? "bg-gray-300" : ""}`}>
                    <span
                      data-toggle="tab"
                      aria-expanded="false"
                      className={`cursor-pointer ${curTab === "Note" ? "text-decoration-none" : ""
                        }`}
                      onClick={() => ClientDetailTab("Note")}
                    >
                      Notes <span className="text-lg" />
                    </span>
                  </li>
                  <li className={`${curTab === "User" ? "bg-gray-300" : ""}`}>
                    <span
                      data-toggle="tab"
                      aria-expanded="false"
                      className={`cursor-pointer ${curTab === "User" ? "text-decoration-none" : ""
                        }`}
                      onClick={() => ClientDetailTab("User")}
                    >
                      Users <span className="text-lg" />
                    </span>
                  </li>

                  {Practice &&
                    sessionStorage.type.toUpperCase() !== "S" &&
                    sessionStorage.type.toUpperCase() !== "IT" &&
                    sessionStorage.type.toUpperCase() !== "D" &&
                    sessionStorage.type.toUpperCase() !== "" && (
                      <li
                        className={`${curTab === "Practice" ? "bg-gray-300" : ""
                          }`}
                      >
                        <span
                          data-toggle="tab"
                          aria-expanded="false"
                          className={`cursor-pointer ${curTab === "Practice"
                              ? "text-decoration-none"
                              : ""
                            }`}
                          onClick={() => ClientDetailTab("Practice")}
                        >
                          Practice Setup <span className="text-lg" />
                        </span>
                      </li>
                    )}
                  {sessionStorage.type.toUpperCase() !== "SP" &&
                    sessionStorage.type.toUpperCase() !== "SA" && (
                      <li
                        className={`${curTab === "Configurations" ? "bg-gray-300" : ""
                          }`}
                      >
                        <span
                          data-toggle="tab"
                          aria-expanded="false"
                          className={`cursor-pointer ${curTab === "Configurations"
                              ? "text-decoration-none"
                              : ""
                            }`}
                          onClick={() => ClientDetailTab("Configurations")}
                        >
                          Configurations Setup{" "}
                          <span className="text-lg" />
                        </span>
                      </li>
                    )}
                  <li
                    className={`${curTab === "plan" ? "bg-gray-300" : ""}`}
                  >
                    <span
                      data-toggle="tab"
                      aria-expanded="false"
                      className={`cursor-pointer ${curTab === "plan" ? "text-decoration-none" : ""
                        }`}
                      onClick={() => ClientDetailTab("plan")}
                    >
                      Project Plan{" "}
                      <span className="text-lg text-red-500">*</span>
                    </span>
                  </li>
                </ul>
                <div
                  className="button-section"
                  onClick={() => RefreshPractice()}
                >
                  <input
                    type="button"
                    className="btnLinkGreen btnUpdate"
                    id="btnPracticeRefresh"
                    value="Refresh"
                  />
                </div>
              </div>
              <div>
                {curTab === "ClientDetail" && (
                  <ClientDetail
                    clientId={clientId}
                    parentCallback={TriggerPracticeSetup}
                  />
                )}

                {curTab === "Ticket" && <ClientTicket clientId={clientId} />}

                {curTab === "Task" && <ClientTask clientId={clientId} />}
                {curTab === "Note" && <ClientNote clientId={clientId} />}
                {curTab === "User" && <ClientUser clientId={clientId} />}
                {curTab === "Configurations" && (
                  <Configurations entityId={entityId} clientId={clientId} />
                )}

                {curTab === "plan" && <ProjectPlan clientId={clientId} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default MainClient;
